import { IPieData } from "../../types/reports";

export const pieData: IPieData = {
  resource_name: "",
  resource_id: 0,
  domain_id: 0,
  total_records: 0,
  total_mismatched_records: 0,
  total_missing_records: 0,
  total_duplicate_records: 0,
  total_unique_records: 0,
  filtered_records_by_resource_filters: 0,
  total_matched_records: 0,
  false_positive_missing_records_count: 0,
  filtered_records_by_rule_filters: 0,
  total_null_key_records: 0,
  countsData: {
    match: 0,
    mismatch: 0,
    missing: 0,
    duplicate: 0,
    total: 0,
    key: 0, // Allow indexing with a string
  },
};
